import { BOX2D_PREFERENCE } from './../external';
export var IS_EXTERNAL_CLASS = Symbol('External class marker');
var LONG_NAMES = /nape./;
var extClassLib = undefined;
export function getExtClassField(name, namespace) {
    if (namespace === void 0) { namespace = undefined; }
    var lib = extClassLib || (extClassLib = BOX2D_PREFERENCE.prefer);
    if (!lib || !name) {
        return null;
    }
    // fast check, for Box2D
    if (!namespace || typeof lib[name] !== 'undefined') {
        return lib[name];
    }
    if (!namespace) {
        return null;
    }
    var trace = lib;
    var path = namespace.split('.');
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var child = path_1[_i];
        trace = trace[child];
        if (!trace) {
            return null;
        }
    }
    return trace[name];
}
/**
 * Try construct object from external lib, like as Box2D or Nape
 * @param mn {Multiname}
 * @param args {any[]}
 */
export function extClassContructor(mn, args) {
    var _a;
    if (!extClassLib) {
        extClassLib = BOX2D_PREFERENCE.prefer;
    }
    if (!extClassLib) {
        return null;
    }
    var ns = (_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri;
    var name = mn.name;
    var isLong = ns && LONG_NAMES.test(ns);
    var Constructor = getExtClassField(name, isLong ? ns : undefined);
    if (typeof Constructor !== 'function') {
        return null;
    }
    Object.defineProperty(Constructor.prototype, IS_EXTERNAL_CLASS, {
        value: true
    });
    // faster that Object.create;
    // class constructor optimized in v8 and WebKit
    // s ... rollup issues =(
    var obj = Object.create(Constructor.prototype);
    Constructor.apply(obj, args);
    // force fast mode;
    // legacy
    obj.__fast__ = true;
    return obj;
}
export function emitIsAX(name) {
    if (!BOX2D_PREFERENCE.prefer) {
        return 'true';
    }
    return "(" + name + " != undefined && " + name + "[AX_CLASS_SYMBOL])";
}
export function needFastCheck() {
    return !!BOX2D_PREFERENCE.prefer;
}
export function emitIsAXOrPrimitive(name, explictNull) {
    if (explictNull === void 0) { explictNull = false; }
    if (!BOX2D_PREFERENCE.prefer) {
        return 'true';
    }
    var nullTest = explictNull ? '' : "|| " + name + " == null";
    return "(_a = typeof " + name + ", ((_a !== 'object' && _a !== 'function' ) " + nullTest + " || " + name + "[AX_CLASS_SYMBOL]))";
}
export function emitIsCallableNative(name, func) {
    if (!BOX2D_PREFERENCE.prefer) {
        return 'false';
    }
    return "( !" + name + "[AX_CLASS_SYMBOL] && typeof " + name + "['" + func + "'] === 'function')";
}
